import React from 'react';
import '../styles/PartnersSection.css';

import emmar_logo from "../assets/images/partner-logos/emmar-logo.png";
import damac_logo from "../assets/images/partner-logos/damac-logo.png";
import sobha_realty_logo from "../assets/images/partner-logos/sobha-realty-logo.jpg";
import danube_properties_logo from "../assets/images/partner-logos/danube-properties-logo.png";
import ellington_properties_logo from "../assets/images/partner-logos/ellington-properties-logo.png";
import binghatti_logo from "../assets/images/partner-logos/binghatti-logo.png";

const partners = [
  emmar_logo,
  damac_logo,
  sobha_realty_logo,
  danube_properties_logo,
  ellington_properties_logo,
  binghatti_logo,
];

const PartnersSection = () => (
  <section className="partners-section">
    <div className="container">
      {partners.map((src, i) => (
        <div 
          key={i} 
          className="partner-logo"
          style={{ animationDelay: `${i * 0.1}s` }}
        >
          <img src={src} alt={`Partner ${i + 1}`} />
        </div>
      ))}
    </div>
  </section>
);

export default PartnersSection; 